export const FETCH_LANDING_PAGES_AUTH = "FETCH_LANDING_PAGES_AUTH";
export const FETCH_LANDING_PAGES_AUTH_SUCCESS = "FETCH_LANDING_PAGES_AUTH_SUCCESS";
